import { Flex, Form, Space, Typography } from "antd"

import Icon from "../../Icon"
import ButtonComponent from "../Button"
import InputComponent from "../Input"
import TextAreaComponent from "../Input/TextArea"

const { Text } = Typography

function ChangeInvoiceAmountForm({
  onClose,
  onSubmit,
  initialValues,
  isDisabledSubmitBtn,
  isSubmitting = false
}) {
  const [form] = Form.useForm()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {error}
    </span>
  )

  const validateMessages = {
    required: addErrorIcon("Required field was not filled.")
  }

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
      {...(initialValues ? { initialValues } : {})}
    >
      <div
      // style={{height: 'min(80vh, 624px)', overflow: 'auto'}}
      >
        <Form.Item
          name="current_invoice_amount"
          label={"Current invoice amount"}
          rules={[{ required: true }]}
        >
          <InputComponent disabled={true} />
        </Form.Item>

        <Form.Item
          name="new_amount"
          label={"New amount"}
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const currentAmount = getFieldValue("current_invoice_amount")
                if (value && currentAmount && Number(value) >= Number(currentAmount)) {
                  return Promise.reject(new Error("Value is higher than the original."))
                }
                return Promise.resolve()
              }
            })
          ]}
        >
          <InputComponent />
        </Form.Item>

        <Form.Item
          name="comment"
          label={"Comment"}
          style={{ marginBottom: 4 }}
          rules={[{ required: true }]}
        >
          <TextAreaComponent rows={3} maxLength={500} name="admin_comment" />
        </Form.Item>

        <Space>
          <Icon type={"circle_info"} style={{ fontSize: 14, color: "#7A7A83" }} />
          <Text type="secondary">Please add calculation details or other comments.</Text>
        </Space>
      </div>
      <Flex gap={16} justify="end" style={{ padding: "32px 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          Cancel
        </ButtonComponent>

        <ButtonComponent
          size="large"
          type="primary"
          htmlType="submit"
          loading={isSubmitting}
          disabled={isDisabledSubmitBtn}
        >
          Change amount
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default ChangeInvoiceAmountForm
